import { countTotalAllDivs } from "../../helpers/countTotal.js";
import { items } from "../../helpers/items.js";
import { toFixed } from '../../global.js';
import { displayMessage } from "../../alert/messageFunc.js";
import { translate } from "../../helpers/translations.js";
import { radiate, startContinuousRadiation, stopContinuousRadiation, radiateDestroyItems, revealNewItemsAfterRadiation, revealNewItemAfterRadiation, revealBetcoinAfterRadiation } from "./reactor-animations.js";

(function ($) {

    // Uncheck all item checkboxes inside inventory after page load
    $('#js__items input.item_checkbox_js').prop('checked', false);

    let ignore_countTotal = false;
    function countTotal() {
        if (ignore_countTotal) {
            return;
        }
        countTotalAllDivs();
        updateExchangeButton();
    }

    function updateExchangeButton() {
        let selected_items = $('.form_for_js_in_div .pay__item input.item_checkbox_js:checked').length;
        let exchange_button = $('.button_for_js_in_div[name="rand_exchanges"]');
        
        if (selected_items > 0) {
            exchange_button.removeClass('disabled').prop('disabled', false);
            exchange_button.removeClass('loading');
            exchange_button.find('.loading-div__mini_b').remove();
        } else {
            exchange_button.addClass('disabled').prop('disabled', true);
        }
    }

    countTotal();

    // Items clicks
    $('.block__item').on('click', '.pay__item', function (e) {
        if ($(this).find('input[type=checkbox]').length == 0) {
            return;
        }
        
        let selected_items_div = $('.form_for_js_in_div .bet-content-show').not('#js__items');
        let user_inventory_div = $('#js__items');
        
        if ($(this).parents('#js__items').length) {
            // Item is in bottom inventory - move to top selected area
            // Set checkbox checked true
            $(this).find('input.item_checkbox_js').prop('checked', true);
            selected_items_div.append($(this));
        } else {
            // Item is in top selected area - move back to bottom inventory
            // Set checkbox checked false
            $(this).find('input.item_checkbox_js').prop('checked', false);
            user_inventory_div.append($(this));
        }
        
        countTotal();
    });

    // Select all button functionality
    $(document).on('click', '#select-all-items', function(e) {
        e.preventDefault();
        selectAllItems();
    });

    function selectAllItems() {
        ignore_countTotal = true;
        let selected_items_div = $('.form_for_js_in_div .bet-content-show').not('#js__items');
        $('#js__items .pay__item:visible').each(function() {
            // Move item to selected area and set checkbox
            $(this).find('input.item_checkbox_js').prop('checked', true);
            selected_items_div.append($(this));
        });
        ignore_countTotal = false;
        countTotal();
    }

    // Deselect all button functionality
    $(document).on('click', '#deselect-all-items', function(e) {
        e.preventDefault();
        deselectAllItems();
    });

    // Take all button functionality (from top area)
    $(document).on('click', '#take-all', function(e) {
        e.preventDefault();
        deselectAllItems();
    });

    function deselectAllItems() {
        ignore_countTotal = true;
        let user_inventory_div = $('#js__items');
        // Move all items from selected area back to inventory
        $('.form_for_js_in_div .bet-content-show').not('#js__items').find('.pay__item').each(function() {
            // Set checkboxes unchecked and move back to inventory
            $(this).find('input.item_checkbox_js').prop('checked', false);
            $(this).find('input[name="receive_item[]"]').prop('checked', false);
            user_inventory_div.append($(this));
        });
        ignore_countTotal = false;
        countTotal();
    }

    // Handle exchange button click
    $('.button_for_js_in_div[name="rand_exchanges"]').on('click', function(e) {
        let selected_items = $('.form_for_js_in_div .pay__item input.item_checkbox_js:checked').length;
        
        if (selected_items === 0) {
            e.preventDefault();
            displayMessage(translate('Please select at least one item'), 'error');
            return false;
        }
    });

    // Initialize button state
    updateExchangeButton();

    // Map server item data to animation format
    function mapServerItemToAnimationFormat(serverItem) {
        // Create market URL for Steam items
        const marketUrl = `http://steamcommunity.com/market/listings/${serverItem.appid}/${encodeURIComponent(serverItem.name)}`;
        
        return {
            title: serverItem.name,
            color: serverItem.item_color,    // Use server-provided color
            appearLvl: serverItem.appearLvl, // Use server-provided animation level
            innerHTML: `
                <input type="hidden" name="appid" value="${serverItem.appid}">
                <div class="pay__item-sum" data-price="${serverItem.price}"><span class="money-amount"><span>$</span><span class="js_amount">${serverItem.price}</span></span><a href="${marketUrl}" target="_blank" title="Steam"></a></div>
                <div class="pay__item-img">
                    <img loading="lazy" style="color: ${serverItem.item_color};" src="${serverItem.img_url}" title="${serverItem.name}" alt="${serverItem.name}">
                </div>
                <div class="pay__item-name" style="color: ${serverItem.item_color};" data-rarity="${serverItem.item_type}" data-game="${serverItem.appid}">${serverItem.name} <span class="pay__item-name-rarity">(${serverItem.item_type})</span></div>
                <label>
                    <input type="checkbox" class="item_checkbox_js" name="bet_item[]" value="${serverItem.id}">
                </label>`
        };
    }

    // Map betcoin reward to animation format
    function mapBetcoinToAnimationFormat(betcoinAmount) {
        return {
            title: `Betcoin ${betcoinAmount}`,
            color: '#fba200', // Use --money-color from main.css
            appearLvl: 1, // High level animation for valuable betcoins
            innerHTML: `
                <div class="bet-content-coin-left">
                    <img src="/template/images/svg/betcoin-icon-big.svg" alt="Betcoin"
                         class="icon to-svg">
                </div>
                <div class="bet-content-coin-right">
                    <b>Betcoin</b>
                    <span><span>$</span><span data-betcoin="${betcoinAmount}">${betcoinAmount}</span></span>
                </div>
<input class="input-necessarily" type="hidden" name="user_betcoin" value="${betcoinAmount}">`
        };
    }

    // Progressive radiation state management
    let radiationInProgress = false;
    let revealedItemIds = new Set(); // Track IDs of already revealed items
    let totalBetcoin = 0; // Track total betcoin amount from latest response
    let radiationStash = null;
    let radiationButton = null;
    let itemRevelationInProgress = false; // Track if items are currently being revealed

    // Start radiation on any processing status (even without items)
    function shouldStartRadiation(data) {
        return data.status === 'processing' || data.status === 'completed';
    }

    // Check if we have actual rewards to reveal
    function hasRewardsToReveal(data) {
        return (data.items && data.items.length > 0) || 
               (data.betcoin && parseFloat(data.betcoin) > 0);
    }

    // Filter new items from cumulative API response
    function getNewItems(responseItems) {
        if (!responseItems || responseItems.length === 0) return [];
        return responseItems.filter(item => {
            // Validate item has a valid ID
            if (!item.id) {
                console.warn('Item missing ID, skipping:', item);
                return false;
            }
            // Check if not already revealed
            return !revealedItemIds.has(item.id);
        });
    }

    // Polling can deliver another response before the current animations finish.
    // Serialize destruction, cumulative reward revelation and final total updates.
    let radiationResponseQueue = Promise.resolve();
    function handleRadiateResponse(data, action, formdiv, post_data, button) {
        if (action !== '/engine/function/items_exchanger/post_items_exchanger.php' || post_data.button_name !== 'rand_exchanges') {
            return false; // Not a radiate request
        }

        radiationResponseQueue = radiationResponseQueue
            .then(() => processRadiateResponse(data, button))
            .catch(error => {
                console.error('Error processing radiation response:', error);
                stopContinuousRadiation();
                resetRadiationState();
            });
        return true; // js_form.js expects a synchronous handled flag.
    }

    async function processRadiateResponse(data, button) {
        if (data.response && data.response.return_url) {
            window.location.assign(data.response.return_url);
            return;
        }
        // Check for errors first - stop radiation if error found
        if (data.error || data.status === 'error') {
            stopContinuousRadiation();
            resetRadiationState();
            finishRadiation();
            return false;
        }

        // Start radiation on any processing status (even without items)
        if (shouldStartRadiation(data)) {
            let stash = button.closest('.block').find('.bet-content-show:not(#js__items)')[0];
            if (!stash) return;

            // Start radiation if not already in progress (first response - processing OR completed)
            if (!radiationInProgress) {
                radiationInProgress = true;
                radiationStash = stash;
                $(stash).closest('.bet-content').find('.bet-content-total').css('visibility', 'hidden');
                revealedItemIds.clear();
                totalBetcoin = 0;

                // Start continuous radiation animation immediately (even without items)
                vibrate(10);
                startContinuousRadiation(); // Keep radiating throughout processing
                await radiateDestroyItems(stash);
            }

            // Only process rewards if we actually have some
            if (hasRewardsToReveal(data)) {
                // Update total betcoin from latest response
                if (data.betcoin && parseFloat(data.betcoin) > 0) {
                    totalBetcoin = parseFloat(data.betcoin);
                }

                // Find and reveal only NEW items from cumulative response (after destruction is complete)
                let newItems = getNewItems(data.items || []);
                console.log(`Radiation response: ${data.items ? data.items.length : 0} total items, ${newItems.length} new items to reveal`);
                
                if (newItems.length > 0) {
                    // Mark these items as revealed immediately to prevent race conditions
                    let newItemIds = newItems.map(item => item.id);
                    console.log('Revealing new item IDs:', newItemIds);
                    newItems.forEach(item => revealedItemIds.add(item.id));
                    
                    // Reveal new items after destruction completes
                    await revealProgressiveItems(stash, newItems);
                } else if (data.items && data.items.length > 0) {
                    console.log('No new items to reveal (all already revealed)');
                }
            } else {
                console.log('Radiation started - waiting for rewards in next response');
            }

            // Handle completion
            if (data.status === 'completed') {
                // Stop continuous radiation before finishing
                stopContinuousRadiation();
                await finishRadiation(stash);
            }

            return true; // Handled
        } else if (data.status === 'error' || (!shouldStartRadiation(data) && radiationInProgress)) {
            // Reset radiation state on error or invalid data
            stopContinuousRadiation();
            resetRadiationState();
            return false;
        }
        
        return false; // Not handled
    }

    // Progressive item revelation during processing
    async function revealProgressiveItems(stash, newItems) {
        if (!newItems || newItems.length === 0) return;
        
        // Set flag to indicate item revelation is in progress
        itemRevelationInProgress = true;
        
        let itemAnimations = newItems.map(item => mapServerItemToAnimationFormat(item));
        // Items appear in server-specified order (no shuffling needed)
        
        // Reveal items sequentially with proper timing
        for (let item of itemAnimations) {
            await revealNewItemAfterRadiation(stash, item);
            // Small delay between items for staggered effect
            await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        // Clear flag when all items in this batch are revealed
        itemRevelationInProgress = false;
    }

    // Finish radiation process
    async function finishRadiation(stash) {
        // Wait for any pending item revelations to complete before showing betcoins
        while (itemRevelationInProgress) {
            await new Promise(resolve => setTimeout(resolve, 100)); // Check every 100ms
        }
        
        // Show total betcoins if any (AFTER all items are revealed)
        if (totalBetcoin > 0) {
            let betcoinAnimation = mapBetcoinToAnimationFormat(totalBetcoin.toFixed(2));
            await revealBetcoinAfterRadiation(stash, betcoinAnimation);
        }

        // Auto-select the new radiated items (only items with checkboxes, not betcoins)
        await new Promise(resolve => setTimeout(resolve, 500));
        $(stash).find('.pay__item input.item_checkbox_js').prop('checked', true);

        // Reset radiation state before processing the next queued response.
        resetRadiationState();

        // Update exchange button state
        updateExchangeButton();
    }

    // Reset radiation state
    function resetRadiationState() {
        // Refresh the total before showing it, including when processing stops on an error.
        countTotal();
        $(radiationStash).closest('.bet-content').find('.bet-content-total').css('visibility', '');
        radiationInProgress = false;
        revealedItemIds.clear();
        totalBetcoin = 0;
        radiationStash = null;
        itemRevelationInProgress = false; // Reset item revelation flag
    }

    // Vibrate function (from reactor-animations.js)
    function vibrate(val = 5) {
        if("vibrate" in navigator) return navigator.vibrate(val);
        if("oVibrate" in navigator) return navigator.oVibrate(val);
        if("mozVibrate" in navigator) return navigator.mozVibrate(val);
        if("webkitVibrate" in navigator) return navigator.webkitVibrate(val);
        return false;
    }

    // Expose the handler globally for js_form.js to use
    window.handleRadiateResponse = handleRadiateResponse;

})(jQuery);
